module.exports = __webpack_public_path__ + "3a7b8be86c36033cc9cfa53774bfacb7.pdf";